import(/* webpackMode: "eager" */ "/vercel/path0/packages/aiia/src/app/[locale]/@drawer/error.tsx");
